import {gql} from "@apollo/client";

export interface CreateDeliveryMutation {
    createDelivery: boolean
}

export const CREATE_DELIVERY_MUTATION = gql`
    mutation CreateDelivery(
        $organizationId: ID!,
        $carId: String!,
        $name: String!,
        $street: String!,
        $postcode: String!,
        $city: String!,
        $phone: String!,
        $date1: Date!,
        $date2: Date!,
        $date3: Date!,
    ){
        createDelivery(
            organizationId: $organizationId,
            carId: $carId,
            name: $name,
            street: $street,
            postcode: $postcode,
            city: $city,
            phone: $phone,
            date1: $date1,
            date2: $date2,
            date3: $date3,
        )
    }
`
